@for (item of list; track item; let last = $last) {
    <span>
    {{ getText(item) }}
        @if (!last) {
            ,
        }
        <br />
  </span>
}
@if (list?.length < 1) {
    <span>-</span>
}